var render = function render(){var _vm=this,_c=_vm._self._c;return _c('n-dropdown',{directives:[{name:"rw",rawName:"v-rw"}],staticClass:"n-dropdown-add",attrs:{"type":"error","text":"add","items":_vm.items,"ghost":""},on:{"on-click":v => { this.$emit('on-click', v); }}})
}
var staticRenderFns = []

export { render, staticRenderFns }